import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import user from './user/reducers'
import menu from './menu/reducers'
import settings from './settings/reducers'
import tags from './tags/reducers'
import products from './products/reducers'
import company from './company/reducers'
import users from './users/reducers'
import groups from './group/reducers'
import project from './project/reducer'
import site from './site/reducer'
import device from './device/reducer'
import tag from './tag/reducer'

export default history =>
  combineReducers({
    router: connectRouter(history),
    user,
    menu,
    settings,
    tags,
    products,
    company,
    users,
    groups,
    project,
    site,
    device,
    tag,
  })
